export default function formatSchedule(arr) {
  const groupedByDay = arr.reduce((result, obj) => {
    const day = obj.day.toLowerCase();
    if (!result[day]) {
      result[day] = [];
    }
    result[day].push({
      opening_time: obj.opening_time,
      closing_time: obj.closing_time,
    });
    return result;
  }, {});

  return [groupedByDay];
}
